"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "devices-list-component"
  }, [_c("b-table", {
    attrs: {
      data: _vm.data,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "deviceName",
      label: "Dispositivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.deviceName) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "userName",
      label: "Usuário"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.user.firstName) + " " + _vm._s(props.row.user.lastName) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "cpf",
      label: "CPF / CNPJ"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.user.cpf) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "deviceModel",
      label: "Modelo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.deviceModel) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "allowAttendanceRecords",
      label: "Permissão"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.allowAttendanceRecords ? "Sim" : "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "fixedDevice",
      label: "Dispositivo Fixo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _vm$farm;
        return [_vm._v("\n      " + _vm._s(props.row.fixedDeviceFarmId === ((_vm$farm = _vm.farm) === null || _vm$farm === void 0 ? void 0 : _vm$farm.id) ? "Sim" : "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Ações"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-dropdown", {
          attrs: {
            position: "is-bottom-left"
          }
        }, [_c("b-button", {
          staticClass: "is-text",
          attrs: {
            slot: "trigger",
            "icon-right": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("toggle-allow", props.row);
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.row.allowAttendanceRecords ? "Recusar marcações" : "Permitir marcações") + "\n        ")]), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("create-fixed", props.row);
            }
          }
        }, [_vm._v("\n          Registrar como dispositivo fixo\n        ")])], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;